import $ from 'jquery'

/* eslint no-multi-spaces: 0 */
function AnimateScroller (node, conf) {
  this.conf     = null
  this.$node    = null
  this.$scroll  = null
  this.offset   = 0
  this.duration = 400
  this.easing   = 'swing'
  this.isBusy   = false
  this.init(node, conf)
}
AnimateScroller.prototype.init = function (node, conf) {
  this.initConf(conf)
  this.initNode(node)
}
AnimateScroller.prototype.initConf = function (conf) {
  const _conf = conf || {}
  this.$container  = _conf.$container || $('body')
  this.offset      = _conf.offset     || this.offset
  this.duration    = _conf.duration   || this.duration
  this.easing      = _conf.easing     || this.easing
}
AnimateScroller.prototype.initNode = function (node) {
  if (node) {
    this.$node = $(node)
  }
}
AnimateScroller.prototype.scrollToHash = function (hash) {
  const _hash = hash || ''
  if (_hash.indexOf('#') === 0 && _hash !== '#') {
    let $target = $(_hash)
    if (!$target.length && _hash === '#top') {
      $target = $('body')
    }
    this.scrollToNode($target)
  }
}
AnimateScroller.prototype.scrollToNode = function (node) {
  if (node) {
    this.scrollTo($(node).offset())
  }
}
AnimateScroller.prototype.scrollTo = function (pos) {
  if (this.$node && this.$node.length) {
    if (pos) {
      this.isBusy = true
      const limit = this.$node.prop('scrollHeight') - (window.innerHeight || $(window).height())
      const top = Math.max(0, Math.min(pos.top - this.offset, limit))
      this.$node
        .stop()
        .animate({ scrollTop: top }, this.duration, this.easing, $.proxy(function () {
          this.isBusy = false
        }, this))
    }
  }
}

export default AnimateScroller
